export const PRIMARY_DATE_FORMAT = "DD-MMM-YYYY";
export const SECONDARY_DATE_FORMAT = "DD-MMM-YYYY";
export const FILE_DATE_FORMAT = PRIMARY_DATE_FORMAT;
export const ALL_USED_DATE_FORMAT = [
  PRIMARY_DATE_FORMAT,
  SECONDARY_DATE_FORMAT,
];
